import { Button, ButtonColor } from "@swivl-mono/ui";

import { Member } from "../../../../../Models/Member/Member.Current";
import MembersModel from "../../../../../Models/Member/Members.Model";
import ModalModel from "../../../../../Models/Modal/Modal.Model";
import "./StartShiftModal.scss";

export const StartShiftModal = () => {
  const goOnlineClicked = () => {
    Member.hasSeenStartShiftModal = true;
    MembersModel.setAvailability(true);
    ModalModel.hideModal();
  };
  const stayOfflineClicked = () => {
    Member.hasSeenStartShiftModal = true;

    MembersModel.setAvailability(false);
    ModalModel.hideModal();
  };

  return (
    <div className="StartShiftModal">
      <span className="text-2xl">🦸‍♀ 💬 👨‍💻</span>
      <div className="mb-6">
        <h2>Welcome to your shift</h2>
        <span>Do you want to turn your availability on?</span>
      </div>

      <div className="buttons">
        <Button color={ButtonColor.BLACK} onClick={stayOfflineClicked}>
          Stay Offline
        </Button>
        <Button color={ButtonColor.ORANGE} onClick={goOnlineClicked}>
          Go Online
        </Button>
      </div>
    </div>
  );
};
